export enum OrderStatusTypes {
  AVAILABLE = 'AVAILABLE',
  PENDING = 'PENDING',
  ACCOMPLISHED = 'ACCOMPLISHED',
}

export enum EOrderStatusFlow {
  PENDING_DOCUMENTATION = 'PENDING_DOCUMENTATION',
  PENDING_ORDER_INFORMATION = 'PENDING_ORDER_INFORMATION',
  PROCESSING = 'PROCESSING',
  REPROVED_WITH_CORRECTION = 'REPROVED_WITH_CORRECTION',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  PAID = 'PAID',
  AVAILABLE_QUOTATION = 'AVAILABLE_QUOTATION',
  REPROVED_WITHOUT_CORRECTION = 'REPROVED_WITHOUT_CORRECTION',
  AVAILABLE_PAYMENT = 'AVAILABLE_PAYMENT',
  PENDING_INVOICE_INFORMATION = 'PENDING_INVOICE_INFORMATION',
  PENDING_INVOICE_ATTACHMENT = 'PENDING_INVOICE_ATTACHMENT',
  IDENTIFYING_PAYMENT = 'IDENTIFYING_PAYMENT',
  IDENTIFIED_PAYMENT = 'IDENTIFIED_PAYMENT',
  IDENTIFYING_PAYMENT_ABROAD = 'IDENTIFYING_PAYMENT_ABROAD',
  IDENTIFIED_PAYMENT_ABROAD = 'IDENTIFIED_PAYMENT_ABROAD',
  PAYMENT_REPROVED = 'PAYMENT_REPROVED',
  PENDING_PAYMENT_INFORMATION = 'PENDING_PAYMENT_INFORMATION',
  PENDING_LIQUIDATION = 'PENDING_LIQUIDATION',

  // Derivados
  PAID_LIQUIDATED = 'PAID_LIQUIDATED',
  PAYMENT_AWAITING_TREASURY = 'PAYMENT_AWAITING_TREASURY',
  PAYMENT_READY_TO_SLIP = 'PAYMENT_READY_TO_SLIP',
  PAYMENT_AWAITING_EFETIVATION = 'PAYMENT_AWAITING_EFETIVATION',
  PAYMENT_CONFIRM_INBOUND = 'PAYMENT_CONFIRM_INBOUND',
  EXCHANGE_NO_PENDING = 'EXCHANGE_NO_PENDING',
  EXCHANGE_PENDING_SETTLEMENT_DOC = 'EXCHANGE_PENDING_SETTLEMENT_DOC',
  EXCHANGE_PENDING_OPERATION_DOC = 'EXCHANGE_PENDING_OPERATION_DOC',
}

export enum ETableInProgressStatusFlow {
  PENDING_DOCUMENTATION = 'Pendente documentação',
  PROCESSING = 'Aguardando avaliação',
  IDENTIFIED_PAYMENT_ABROAD = 'Pendente informações',
  PENDING_PAYMENT_INFORMATION = 'Pendente informações de pagamento',
  PENDING_INVOICE_INFORMATION = 'Pendente informações da invoice',
  PENDING_INVOICE_ATTACHMENT = 'Invoice pendente',
  AVAILABLE_QUOTATION = 'Aguardando cotação',
  IDENTIFYING_PAYMENT_ABROAD = 'Aguardando pagamento no exterior',
  PAYMENT_REPROVED = 'Ordem com pendência',
  REPROVED_WITH_CORRECTION = 'Reprovada',
  IDENTIFIED_PAYMENT = 'Efetivada',
  PAYMENT_AWAITING_TREASURY = 'Aguardando informações da tesouraria',
  PAYMENT_READY_TO_SLIP = 'Pronto para boletar',
  PENDING_ORDER_INFORMATION = 'Pendente informações',
  PAYMENT_AWAITING_EFETIVATION = 'Aguardando efetivação',
  PAYMENT_CONFIRM_INBOUND = 'A confirmar pagamento',
}

export enum ETableFinishedStatusFlow {
  PAID_LIQUIDATED = 'Liquidada',
  CANCELED = 'Cancelada',
  EXCHANGE_NO_PENDING = 'Sem pendências',
  EXCHANGE_PENDING_SETTLEMENT_DOC = 'Pendente doc liquidação',
  EXCHANGE_PENDING_OPERATION_DOC = 'Pendente doc operação',
}
